let yowsClient;

const set = (client) => {
  yowsClient = client;
};

const get = () => yowsClient;

export default { set, get };
